export interface ThemeConfig {
  id?: string;
  // Light mode kleuren
  primary_color_light: string;
  secondary_color_light: string;
  accent_color_light: string;
  background_light: string;
  // Dark mode kleuren
  primary_color_dark: string;
  secondary_color_dark: string;
  accent_color_dark: string;
  background_dark: string;
  // Metadata
  created_at?: string;
  updated_at?: string;
}

export const DEFAULT_THEME: ThemeConfig = {
  primary_color_light: '220 90% 56%',
  primary_color_dark: '220 90% 65%',
  secondary_color_light: '25 95% 53%',
  secondary_color_dark: '25 95% 60%',
  accent_color_light: '25 95% 53%',
  accent_color_dark: '25 95% 60%',
  background_light: '0 0% 100%',
  background_dark: '220 13% 9%',
};

export const THEME_PRESETS: Record<string, ThemeConfig> = {
  professional_blue: {
    primary_color_light: '220 90% 56%',
    primary_color_dark: '220 90% 65%',
    secondary_color_light: '25 95% 53%',
    secondary_color_dark: '25 95% 60%',
    accent_color_light: '25 95% 53%',
    accent_color_dark: '25 95% 60%',
    background_light: '0 0% 100%',
    background_dark: '220 13% 9%',
  },
  vibrant_purple: {
    primary_color_light: '270 95% 60%',
    primary_color_dark: '270 95% 70%',
    secondary_color_light: '290 95% 65%',
    secondary_color_dark: '290 95% 72%',
    accent_color_light: '310 95% 60%',
    accent_color_dark: '310 95% 68%',
    background_light: '0 0% 100%',
    background_dark: '270 20% 10%',
  },
  elegant_green: {
    primary_color_light: '145 70% 45%',
    primary_color_dark: '145 70% 55%',
    secondary_color_light: '165 70% 50%',
    secondary_color_dark: '165 70% 58%',
    accent_color_light: '185 70% 45%',
    accent_color_dark: '185 70% 55%',
    background_light: '0 0% 100%',
    background_dark: '145 15% 12%',
  },
  bold_orange: {
    primary_color_light: '25 95% 53%',
    primary_color_dark: '25 95% 62%',
    secondary_color_light: '45 95% 55%',
    secondary_color_dark: '45 95% 62%',
    accent_color_light: '15 95% 50%',
    accent_color_dark: '15 95% 58%',
    background_light: '0 0% 100%',
    background_dark: '25 20% 10%',
  },
  minimalist_gray: {
    primary_color_light: '210 10% 40%',
    primary_color_dark: '210 10% 60%',
    secondary_color_light: '210 10% 50%',
    secondary_color_dark: '210 10% 65%',
    accent_color_light: '210 15% 45%',
    accent_color_dark: '210 15% 60%',
    background_light: '0 0% 98%',
    background_dark: '210 10% 8%',
  },
  ocean_blue: {
    primary_color_light: '200 80% 45%',
    primary_color_dark: '200 80% 55%',
    secondary_color_light: '180 70% 50%',
    secondary_color_dark: '180 70% 58%',
    accent_color_light: '190 75% 48%',
    accent_color_dark: '190 75% 56%',
    background_light: '200 20% 98%',
    background_dark: '200 25% 8%',
  },
  sunset_warm: {
    primary_color_light: '15 85% 55%',
    primary_color_dark: '15 85% 63%',
    secondary_color_light: '40 90% 50%',
    secondary_color_dark: '40 90% 58%',
    accent_color_light: '25 90% 52%',
    accent_color_dark: '25 90% 60%',
    background_light: '30 30% 98%',
    background_dark: '20 30% 8%',
  },
  forest_green: {
    primary_color_light: '140 60% 40%',
    primary_color_dark: '140 60% 52%',
    secondary_color_light: '160 55% 45%',
    secondary_color_dark: '160 55% 55%',
    accent_color_light: '120 50% 42%',
    accent_color_dark: '120 50% 52%',
    background_light: '140 15% 98%',
    background_dark: '140 20% 8%',
  },
  royal_purple: {
    primary_color_light: '265 85% 55%',
    primary_color_dark: '265 85% 65%',
    secondary_color_light: '285 80% 60%',
    secondary_color_dark: '285 80% 68%',
    accent_color_light: '245 75% 58%',
    accent_color_dark: '245 75% 66%',
    background_light: '265 15% 98%',
    background_dark: '265 25% 8%',
  },
  slate_modern: {
    primary_color_light: '215 25% 45%',
    primary_color_dark: '215 25% 60%',
    secondary_color_light: '220 20% 55%',
    secondary_color_dark: '220 20% 68%',
    accent_color_light: '210 30% 50%',
    accent_color_dark: '210 30% 62%',
    background_light: '215 15% 98%',
    background_dark: '215 20% 8%',
  },
  coral_pink: {
    primary_color_light: '350 80% 60%',
    primary_color_dark: '350 80% 68%',
    secondary_color_light: '340 75% 65%',
    secondary_color_dark: '340 75% 72%',
    accent_color_light: '0 85% 58%',
    accent_color_dark: '0 85% 66%',
    background_light: '350 20% 98%',
    background_dark: '350 25% 8%',
  },
  midnight_dark: {
    primary_color_light: '230 70% 50%',
    primary_color_dark: '230 70% 62%',
    secondary_color_light: '250 65% 55%',
    secondary_color_dark: '250 65% 65%',
    accent_color_light: '220 75% 52%',
    accent_color_dark: '220 75% 62%',
    background_light: '230 15% 98%',
    background_dark: '230 30% 6%',
  },
  terracotta: {
    primary_color_light: '20 70% 50%',
    primary_color_dark: '20 70% 60%',
    secondary_color_light: '35 65% 55%',
    secondary_color_dark: '35 65% 63%',
    accent_color_light: '10 75% 48%',
    accent_color_dark: '10 75% 58%',
    background_light: '25 25% 98%',
    background_dark: '20 25% 8%',
  },
};
